export const APPLY_EAGRID_QUERY_EVENT = 'apply_eag_grid_query_event';

export type ApplyEagridQueryCustomEvent = {
  gridCode: string;
  dataQueryId: string;
  /** Echoed on the result event so a caller can tell this apply's acknowledgement from a retry's. */
  requestId?: string;
};

declare global {
  interface WindowEventMap {
    [APPLY_EAGRID_QUERY_EVENT]: CustomEvent<ApplyEagridQueryCustomEvent>;
  }
}

// Fire-and-forget dispatcher: inert when no grid with this code is mounted.
export const applyDataGridQuery = (gridCode: string, dataQueryId: string, requestId?: string) => {
  const event = new CustomEvent(APPLY_EAGRID_QUERY_EVENT, {
    detail: {gridCode, dataQueryId, requestId},
  });

  window.dispatchEvent(event);
};
